import { api } from '../../api'
import { ApiParams, GetSuppliersByFiltersResponse } from '../../types'

const getSuppliersByFilters = async ({ filters }: ApiParams) => {
  const response = await api.get<GetSuppliersByFiltersResponse>('/suppliers', {
    params: filters,
  })

  return response.data.suppliers
}

const SuppliersViewApi = { getSuppliersByFilters }

export default SuppliersViewApi
